import ForgotPassword from './ForgotPassword'
import ResetPassword from './ResetPassword'
import ChangeData from './ChangeData'
import InvoiceSettings from './InvoiceSettings'
import EmployeeSettings from './EmployeeSettings'
import NotificationSettings from './NotificationSettings'
import ChangeEmail from './ChangeEmail'
import ChangePassword from './ChangePassword'
import EmailConfirmation from './EmailConfirmation'
import DeleteAccount from './DeleteAccount'
import Settings from './Settings'
import Signup from './Signup'
import Login from './Login'
import ProfileSettings from './ProfileSettings'
import OtherSettings from './OtherSettings'
import Logout from './Logout'

export const accountPages = {
    forgotpassword: ForgotPassword,
    resetpassword: ResetPassword,
    changedata: ChangeData,
    invoicesettings: InvoiceSettings,
    employeesettings: EmployeeSettings,
    notificationsettings: NotificationSettings,
    changeemail: ChangeEmail,
    changepassword: ChangePassword,
    emailconfirmation: EmailConfirmation,
    deleteaccount: DeleteAccount,
    settings: Settings,
    signup: Signup,
    login: Login,
    profilesettings: ProfileSettings,
    othersettings: OtherSettings,
    logout: Logout
}
